<template>
  <div class="dividend-transfer-wrapper">
    <DividendsDetails :initLength="10" class="section-margin"><MoreTitle title="分红派息" /></DividendsDetails>
    <RepurchaseHk v-if="market === 'hk'" showFooter><MoreTitle title="回购" /></RepurchaseHk>
    <RepurchaseHs v-else-if="market === 'hs'" showFooter><MoreTitle title="回购" /></RepurchaseHs>
    <Split v-if="market !== 'hs'" showFooter><MoreTitle title="拆股并股" /></Split>
  </div>
</template>

<script>
import RepurchaseHk from '@/components/f10/behavior/RepurchaseHk.vue'
import RepurchaseHs from '@/components/f10/behavior/RepurchaseHs.vue'
import Split from '@/components/f10/behavior/Split.vue'
import DividendsDetails from '@/components/f10/behavior/DividendsDetails.vue'
import { sendMsg } from '@/plugins/msg'
export default {
  components: { RepurchaseHk, RepurchaseHs, Split, DividendsDetails },
  computed: {
    symbol() {
      return this.$route.query.symbol
    },
    market() {
      return this.$funs.getMarket(this.symbol)
    }
  },
  created() {
    sendMsg({ event: 'setTitle', title: '分红送转' })
  }
}
</script>

<style lang="scss" scoped></style>
